<template>
  <el-dialog
    :visible.sync="isShown"
    :title="titleStr">
    <el-form v-model="form" label-width="120px">
      <el-form-item label="勤務日" required>
        <el-input v-if="planPk" v-model="form.date" type="date" :style="{width: '230px'}" size="mini" />
        <el-date-picker
          v-else
          v-model="form.date"
          type="date"
          :style="{width: '130px'}"
          size="mini"
          :clearable="false">
        </el-date-picker>
        <span v-show="form.date">{{ form.date|printYoubi }}</span>
      </el-form-item>
      <el-form-item label="勤務先店舗" required>
        <el-select v-model="form.shop" size="mini">
          <el-option
            v-for="s in shops"
            :key="s.pk"
            :label="s.name"
            :value="s.pk">
          </el-option>
        </el-select>
        <div class="shop-info" v-if="form.shop">
          開店時間: {{ this.openTime }} 〜 {{ this.closeTime }}
        </div>
      </el-form-item>
      <el-form-item label="スタッフ" v-model="form.staff" :error="errors.staff.join(', ')" required>
        <el-select v-model="form.staff" size="mini">
          <el-option v-for="staff in staffs" :label="staff.name" :key="staff.pk" :value="staff.pk">{{ staff.name + `(${staff.shopName})` }}</el-option>
        </el-select>
        <div class="staff-info" v-if="form.staff">
          所属店舗: {{ staffData.shopName }}
        </div>
      </el-form-item>
      <el-form-item label="勤務時間">
        <el-time-select
          v-model="form.startTime"
          :disabled="form.isVacation || form.isPaidVacation"
          size="mini"
          :style="{width: '100px'}"
          :picker-options="pickerOptions">
        </el-time-select> 〜
        <el-time-select
          v-model="form.endTime"
          :disabled="form.isVacation || form.isPaidVacation"
          size="mini"
          :style="{width: '100px'}"
          :picker-options="pickerOptions">
        </el-time-select>
      </el-form-item>

      <el-form-item label="">
        <el-checkbox v-model="form.autoAddBreak" disabled>休憩時間自動設定</el-checkbox>
      </el-form-item>
      <el-form-item label="休憩時間">
        <el-time-select
          v-model="form.breakStartTime"
          :disabled="form.isVacation || form.isPaidVacation || form.autoAddBreak"
          size="mini"
          :style="{width: '100px'}"
          :picker-options="pickerOptions">
        </el-time-select> 〜
        <el-time-select
          v-model="form.breakEndTime"
          :disabled="form.isVacation || form.isPaidVacation || form.autoAddBreak"
          size="mini"
          :style="{width: '100px'}"
          :picker-options="pickerOptions">
        </el-time-select>
      </el-form-item>

      <el-form-item label="予定1">
        <el-time-select
          v-model="form.blockStartTime"
          :disabled="form.isVacation || form.isPaidVacation"
          size="mini"
          :style="{width: '100px'}"
          :picker-options="pickerOptions">
        </el-time-select> 〜
        <el-time-select
          v-model="form.blockEndTime"
          :disabled="form.isVacation || form.isPaidVacation"
          size="mini"
          :style="{width: '100px'}"
          :picker-options="pickerOptions">
        </el-time-select>
      </el-form-item>
      <el-form-item label="理由">
        <el-input v-model="form.blockReason_1" size="mini" :style="{width: '130px'}" />
      </el-form-item>

      <el-form-item label="予定2">
        <el-time-select
          v-model="form.blockStartTime2"
          :disabled="form.isVacation || form.isPaidVacation"
          size="mini"
          :style="{width: '100px'}"
          :picker-options="pickerOptions">
        </el-time-select> 〜
        <el-time-select
          v-model="form.blockEndTime2"
          :disabled="form.isVacation || form.isPaidVacation"
          size="mini"
          :style="{width: '100px'}"
          :picker-options="pickerOptions">
        </el-time-select>
      </el-form-item>
      <el-form-item label="理由">
        <el-input v-model="form.blockReason_2" size="mini" :style="{width: '130px'}" />
      </el-form-item>

      <el-form-item label="">
        <el-checkbox v-model="form.isVacation" @change="changeIsVacation">希望休</el-checkbox>
        <el-checkbox v-model="form.isPaidVacation" @change="changeIsPaidVacation">有給休暇</el-checkbox>
      </el-form-item>
    </el-form>
    <error-list :errors="errors.nonFieldErrors" />
    <div slot="footer">
      <el-button @click="submit" :disabled="isSending" type="primary">更新</el-button>
      <el-button @click="deletePlan" v-show="planPk" :disabled="isSending" type="danger">削除</el-button>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import zeroPadding from '@/misc/zeroPadding'

import ErrorList from '@/parts/ErrorList'

const defaultFormValue = {
  startTime: null,
  endTime: null,
  breakStartTime: null,
  breakEndTime: null,
  date: null,
  shop: null,
  staff: null,
  isVacation: false,
  isPaidVacation: false,
  autoAddBreak: true,
  blockStartTime: null,
  blockEndTime: null,

  blockStartTime2: null,
  blockEndTime2: null,
  blockReason_2: '',
}

export default {
  name: 'ShiftPlanEditDialog',
  components: {
    ErrorList,
  },
  props: {
    shops: {
      type: Array,
    },
    currentShop: {
      type: String,
    },
    items: {
      type: Array,
    },
    staffs: {
      type: Array,
    },
    year: {
      type: [Number, String],
    },
    month: {
      type: [Number, String],
    },
  },
  data () {
    return {
      isShown: false,
      isSending: false,
      date: null,
      planPk: null,
      openTime: '08:30',
      closeTime: '21:00',
      form: {...defaultFormValue},
      errors: {
        staff: [],
        nonFieldErrors: [],
      },
    }
  },
  filters: {
    printYoubi (val) {
      if (!val) {
        return ''
      }
      return moment(val).locale('ja').format('dddd')
    },
  },
  computed: {
    titleStr () {
      return this.planPk ? 'シフト変更' : 'シフト入力'
    },
    pickerOptions () {
      let [h, m] = this.openTime.split(':')
      let openHour = parseInt(h) - 1
      let openMinute = parseInt(m)

      if (openMinute > 0 && openMinute < 30) {
        openMinute = 0
      } else if (openMinute > 30 && openMinute < 60) {
        openMinute = 30
      }

      [h, m] = this.closeTime.split(':')
      let closeHour = parseInt(h) + 1
      let closeMinute = parseInt(m)

      if (closeMinute > 0 && closeMinute < 30) {
        closeMinute = 0
      } else if (closeMinute > 30 && closeMinute < 60) {
        closeMinute = 30
      }

      openHour = zeroPadding(openHour)
      openMinute = zeroPadding(openMinute)
      closeHour = zeroPadding(closeHour)
      closeMinute = zeroPadding(closeMinute)

      return {
        start: `${openHour}:${openMinute}`,
        end: `${closeHour}:${closeMinute}`,
        step: '00:10',
      }
    },
    printDate () {
      return moment(this.date).locale('ja').format('MM/DD (ddd)')
    },
    currentShopData () {
      return this.shops.find(x => x.pk === this.currentShop)
    },
    shopData () {
      return this.shops.find(x => x.pk === this.form.shop)
    },
    staffData () {
      if (!this.form.staff) {
        return null
      }
      return this.staffs.find(x => x.pk === this.form.staff)
    },
  },
  methods: {
    showWithoutData () {
      // 日付をクリックしない場合
      console.log('show!')
      this.reset()
      this.form.date = moment().year(this.year).month(this.month - 1).date(1).toDate()
      this.form.shop = this.currentShop
      console.log(this.form.date)
      this.isShown = true
    },
    show (date, staffData, planData) {
      this.reset()

      this.form.staff = staffData.pk
      this.form.shop = this.currentShop

      if (date) {
        const tmp = this.items.find(x => x.date === date)
        this.closeTime = tmp.closeTime
        this.openTime = tmp.openTime
        this.form.date = date
      }

      if (planData) {
        console.log('planData', planData)
        this.planPk = planData.pk
        this.form.shop = planData.shop
        this.form.staff = planData.staff
        if (planData.startHour) {
          const startHour = zeroPadding(planData.startHour)
          const startMinute = zeroPadding(planData.startMinute)
          const endHour = zeroPadding(planData.endHour)
          const endMinute = zeroPadding(planData.endMinute)
          this.form.startTime = `${startHour}:${startMinute}`
          this.form.endTime = `${endHour}:${endMinute}`
        }

        this.form.isVacation = planData.isVacation
        this.form.isPaidVacation = planData.isPaidVacation

        if (planData.breakStartHour_1) {
          const breakStartHour = zeroPadding(planData.breakStartHour_1)
          const breakStartMinute = zeroPadding(planData.breakStartMinute_1)
          this.form.breakStartTime = `${breakStartHour}:${breakStartMinute}`
        }
        if (planData.breakEndHour_1) {
          const breakEndHour = zeroPadding(planData.breakEndHour_1)
          const breakEndMinute = zeroPadding(planData.breakEndMinute_1)
          this.form.breakEndTime = `${breakEndHour}:${breakEndMinute}`
        }
        if (planData.blockStartHour_1) {
          const blockStartHour = zeroPadding(planData.blockStartHour_1)
          const blockStartMinute = zeroPadding(planData.blockStartMinute_1)
          this.form.blockStartTime = `${blockStartHour}:${blockStartMinute}`
        }
        if (planData.blockEndHour_1) {
          const blockEndHour = zeroPadding(planData.blockEndHour_1)
          const blockEndMinute = zeroPadding(planData.blockEndMinute_1)
          this.form.blockEndTime = `${blockEndHour}:${blockEndMinute}`
        }

        this.form.blockReason_1 = planData.blockReason_1 || ''

        if (planData.blockStartHour_2) {
          const blockStartHour = zeroPadding(planData.blockStartHour_2)
          const blockStartMinute = zeroPadding(planData.blockStartMinute_2)
          this.form.blockStartTime2 = `${blockStartHour}:${blockStartMinute}`
        }
        if (planData.blockEndHour_2) {
          const blockEndHour = zeroPadding(planData.blockEndHour_2)
          const blockEndMinute = zeroPadding(planData.blockEndMinute_2)
          this.form.blockEndTime2 = `${blockEndHour}:${blockEndMinute}`
        }
        this.form.blockReason_2 = planData.blockReason_2
      } else {
        this.planPk = null
      }
      this.isShown = true
    },
    reset () {
      this.planPk = null
      this.form = {...defaultFormValue}
      Object.keys(this.errors).forEach(key => {
        this.errors[key] = []
      })
    },
    hide () {
      this.isShown = false
    },
    submit () {
      if (this.isSending) {
        return
      }
      if (!this.form.isVacation && !this.form.isPaidVacation && (!this.form.startTime || !this.form.endTime)) {
        this.errors.nonFieldErrors = ['勤務時間もしくは希望休を入力してください']
        return
      }
      let tmp = !this.form.startTime ? [null, null] : this.form.startTime.split(':')
      const startHour = tmp[0]
      const startMinute = tmp[1]

      tmp = !this.form.endTime ? [null, null] : this.form.endTime.split(':')
      const endHour = tmp[0]
      const endMinute = tmp[1]

      let breakStartHour, breakStartMinute, breakEndHour, breakEndMinute
      if (this.form.breakStartTime && this.form.breakEndTime) {
        tmp = this.form.breakStartTime.split(':')
        breakStartHour = tmp[0]
        breakStartMinute = tmp[1]

        tmp = this.form.breakEndTime.split(':')
        breakEndHour = tmp[0]
        breakEndMinute = tmp[1]
      } else {
        breakStartHour = null
        breakStartMinute = null
        breakEndHour = null
        breakEndMinute = null
      }
      /* eslint camelcase: 0 */
      let blockStartHour_1 = null
      let blockStartMinute_1 = null
      let blockEndHour_1 = null
      let blockEndMinute_1 = null
      const {blockStartTime, blockEndTime} = this.form
      if (blockStartTime && blockEndTime) {
        let [sh, sm] = blockStartTime.split(':')
        blockStartHour_1 = sh
        blockStartMinute_1 = sm
        let [eh, em] = blockEndTime.split(':')
        blockEndHour_1 = eh
        blockEndMinute_1 = em
      }
      let blockStartHour_2 = null
      let blockStartMinute_2 = null
      let blockEndHour_2 = null
      let blockEndMinute_2 = null
      const {blockStartTime2, blockEndTime2} = this.form
      if (blockStartTime2 && blockEndTime2) {
        let [sh, sm] = blockStartTime2.split(':')
        blockStartHour_2 = sh
        blockStartMinute_2 = sm
        let [eh, em] = blockEndTime2.split(':')
        blockEndHour_2 = eh
        blockEndMinute_2 = em
      }

      const data = {
        staff: this.form.staff,
        shop: this.form.shop,
        startHour,
        startMinute,
        endHour,
        endMinute,
        breakStartHour_1: breakStartHour,
        breakStartMinute_1: breakStartMinute,
        breakEndHour_1: breakEndHour,
        breakEndMinute_1: breakEndMinute,
        isVacation: this.form.isVacation,
        isPaidVacation: this.form.isPaidVacation,
        autoAddBreak: this.form.autoAddBreak,
        blockStartHour_1,
        blockStartMinute_1,
        blockEndHour_1,
        blockEndMinute_1,
        blockReason_1: this.form.blockReason_1,

        blockStartHour_2,
        blockStartMinute_2,
        blockEndHour_2,
        blockEndMinute_2,
        blockReason_2: this.form.blockReason_2,
      }
      data.date = moment(this.form.date).format('YYYY-MM-DD')

      this.isSending = true
      const api = this.planPk ? this.$request.shifts.planUpdate(this.planPk, data) : this.$request.shifts.planCreate(data)
      api.then(res => {
        this.$message({
          type: 'success',
          message: this.planPk ? '更新しました' : '作成しました',
        })
        this.$emit('update', res.body)
        this.hide()
      }, err => {
        if (err.status === 400) {
          this.$err400(err)
          console.log(this.errors)
        }
        console.log(err)
      }).finally(() => {
        this.isSending = false
      })
    },
    deletePlan () {
      console.log('delete', this.planPk)
      if (this.isSending || !this.planPk) {
        return
      }
      this.isSending = true
      this.$request.shifts.planDelete(this.planPk).then(() => {
        this.$message({
          type: 'success',
          message: '予定を削除しました',
        })
        this.$emit('delete', this.planPk)
        this.hide()
      }).finally(() => {
        this.isSending = false
      })
    },
    changeIsVacation (val) {
      if (val) {
        this.form.isPaidVacation = false
      }
    },
    changeIsPaidVacation (val) {
      if (val) {
        this.form.isVacation = false
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ShiftPlan/EditDialog.vue